/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Numbers = () => {
  const { t, i18n } = useTranslation();

  // عند تغيير اللغة نحدّث خصائص <html>
  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir  = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <div className="section-padding bg-[url('../images/all-img/section-bg-16.png')] bg-cover bg-no-repeat lg:mt-[136px]">
      <div className="container lg:-mt-[250px] xl:pb-[136px] lg:pb-20 pb-10">
        <div className="text-center">
          <div className="column-title">
            {t("achievements.title").split(" ")[0]}{" "}
            <span className="shape-bg">
              {t("achievements.title").split(" ")[1]}
            </span>{" "}
            {t("achievements.title").split(" ").slice(2).join(" ")}
          </div>
        </div>
        <div
          className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] bg-white shadow-box14 rounded-md
               "
        >
          <div className="text-center">
            <h2 className="text-secondary font-bold">
              <span className="counter " style={{ fontSize: 'smaller' }} id="num_counter">
                   {i18n.language === 'en'
          ? 'number one'
          : 'رقم واحد'}
              </span>
            </h2>
            <span className="block text-black font-semibold">
              {t("numbers.enrolled_students")}
            </span>
          </div>

          {/* if( arabic ) {
  <div className="text-center">
            <h2 className="text-secondary font-bold">
              <span className="counter"> رقم واحد </span>
            </h2>
            <span className="block text-black font-semibold">
              {t("numbers.enrolled_students")}
            </span>
          </div>

          }else{
              <div className="text-center">
            <h2 className="text-secondary font-bold">
              <span className="counter"> number 1 </span>
            </h2>
            <span className="block text-black font-semibold">
              {t("numbers.enrolled_students")}
            </span>
          </div>
          } */}




          <div className="text-center">
            <h2 className="text-secondary font-bold">
              <span className="counter">+2500</span>
            </h2>
            <span className="block text-black font-semibold">
              {t("numbers.academic_programs")}
            </span>
          </div>

          <div className="text-center">
            <h2 className="text-secondary font-bold">
              <span className="counter">+9700</span>
            </h2>
            <span className="block text-black font-semibold">
              {t("numbers.winning_award")}
            </span>
          </div>

          <div className="text-center">
            <h2 className="text-secondary font-bold">
              <span className="counter">+11</span>
            </h2>
            <span className="block text-black font-semibold">
              {t("numbers.certified_students")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Numbers;
